import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteCustomField = {
  name: "deleteCustomField" as const,
  input: z.object({ declarationId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
